import { render, staticRenderFns } from "./ArticleViewMobile.vue?vue&type=template&id=65b91740&scoped=true"
import script from "./ArticleViewMobile.vue?vue&type=script&lang=js"
export * from "./ArticleViewMobile.vue?vue&type=script&lang=js"
import style0 from "./ArticleViewMobile.vue?vue&type=style&index=0&id=65b91740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b91740",
  null
  
)

export default component.exports